import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectReportAdminV2Domain = (state) =>
  state.get("reportAdminV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("isLoading"))

export const makeSelectIsMeasureProcess = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("isMeasureProcess"))

export const makeSelectDivisionsAvailable = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("divisionsAvailable"))

export const makeSelectDivisionsData = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("divisionsData"))

export const makeSelectMeasureGeneral = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("measureGeneral"))

export const makeSelectMeasureTotal = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("measureTotal"))

export const makeSelectMeasureConfig = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("measureConfig"))

export const makeSelectIsSectorDataAvailable = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("isSectorDataAvailable"))

export const makeSelectCompanySectors = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("companySectors"))

export const makeSelectCompanySectorsGlobal = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("companySectorsGlobal"))

export const makeSelectCompanySector = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("companySector"))

export const makeSelectIsErrorStatus = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("isErrorStatus"))

export const makeSelectMeasureColorRange = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("measureColorRange"))

export const makeSelectIsLoadingTotal = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("isLoadingTotal"))

export const makeSelectIsLoadingSaveConfig = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("isLoadingSaveConfig"))

export const makeSelectUserType = () =>
  createSelector(selectReportAdminV2Domain, (state) => state.get("userType"))

export { selectReportAdminV2Domain }
